const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const parseOtherStudentEmails = (value) =>
  typeof value === "string"
    ? value.split(",").map((email) => email.trim()).filter(Boolean)
    : [];

/**
 * Field level check on the raw input.
 * @returns {string|null} error message, or null when the input looks usable
 */
export const validateOtherStudentEmails = (value) => {
  const emails = parseOtherStudentEmails(value);
  if (emails.length === 0) return "Other students emails are required";

  const invalid = emails.filter((email) => !EMAIL_PATTERN.test(email));
  if (invalid.length > 0) {
    return `Invalid email: ${invalid.join(", ")}`;
  }

  return null;
};

/**
 * Emails the API rejected as not registered on the platform, if any.
 * @returns {string[]}
 */
export const unregisteredEmailsFromError = (error) => {
  if (error?.response?.status !== 400) return [];

  const data = error?.response?.data?.data;
  if (!Array.isArray(data) || data.length === 0) return [];
  return data.every((item) => typeof item === "string") ? data : [];
};

export const unregisteredEmailsMessage = (emails) =>
  `Not registered on the platform: ${emails.join(", ")}`;
